/**
 * Font utilities for consistent typography across the application
 */

// Global configuration for monospace font usage in numeric displays
export const ENABLE_MONOSPACE_FONT = true;

/**
 * Get the appropriate font family for numeric displays
 * @returns {string} Font family string - monospace or inherit based on configuration
 */
export const getNumericFontFamily = () => {
  return ENABLE_MONOSPACE_FONT
    ? 'SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace'
    : "inherit";
};

/**
 * Get monospace font family string for use in inline styles
 * @returns {string} Monospace font family string
 */
export const getMonospaceFontFamily = () => {
  return 'SFMono-Regular, Consolas, "Liberation Mono", Menlo, monospace';
};

/**
 * Check if monospace font is enabled
 * @returns {boolean} True if monospace font should be used for numeric displays
 */
export const isMonospaceFontEnabled = () => {
  return ENABLE_MONOSPACE_FONT;
};
